<!-- 门店列表 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.keywords" placeholder="搜索"></Input>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.status" clearable filterable placeholder="门店状态">
                <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal">新增门店</Button>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="show_logo">
                        <div class="flex-c">
                            <img class="table_picture" v-if="row.show_logo" :src="row.show_logo">
                            <img class="table_picture" v-else src="../../assets/example1.png">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="type">
                        <div>{{ row.type.name }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <i-switch v-model="row.status" size="large" true-color="#FF761D" :true-value="1" :false-value="0"  @on-change="changeStatus(row, $event)">
                            <span slot="open">正常</span>
                            <span slot="close">禁用</span>
                        </i-switch>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost label="small" @click="goModal(row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(row)">删除</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal v-model="modals" :title="modalTitle" width="500" :mask-closable="false">
            <div>
                <Form :model="formData" label-position="right" :label-width="100">
                    <FormItem label="门店图片:">
                        <div class="form_upload" @click="openModal(1)">
                            <img class="width_height_100" v-if="show_logo" :src="show_logo">
                            <Icon v-else type="ios-add" size="44" color="#AEAEB3"/>
                        </div>
                    </FormItem>
                    <FormItem label="门店名称:">
                        <Input class="w200" type="text" v-model="formData.name" placeholder="请输入门店名称"></Input>
                    </FormItem>
                    <FormItem label="门店类型:">
                        <Select class="w200" v-model="formData.type_id" clearable filterable placeholder="请选择门店类型">
                            <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                            <div slot="content"><p>没有请提前添加<span class="t-color">门店类型</span></p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="门店地址:">
                        <Input class="w200" type="text" v-model="formData.address" placeholder="请输入门店地址"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitModal">确定</Button>
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import { 
    store_list, 
    store_save, 
    store_status, 
    store_delete, 
} from '@/api/index';
import { 
    store_type_select,
} from '@/api/select';
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: { pictureLibrary },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            imgConfig: config.apiUrl + '/',
            uploadImg: config.apiUrl + "/adminapi/file_upload",
            headers: { "hlzw-suyuan-token": getCookies("pcToken") },
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
                status: "",
            },
            total: 0,
            statusList: [
                { id: -1, name: "所有" },
                { id: 0, name: "禁止" },
                { id: 1, name: "启用" },
            ],
            columnsTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "门店图片", slot: "show_logo", align: "center" },
                { title: "门店名称", key: "name", align: "center" },
                { title: "门店类型", slot: "type", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "250px" },
            ],
            dataTable: [],
            formData: {
                id: "",
                name: "",
                logo: "",
                type_id: "",
                address: "",
            },
            show_logo: '',
            typeList: [],
            modals: false,
            modalTitle: "",
        };
    },
    mounted() {
        this.getList();
        this.getStoreTypeSelect();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.show_logo = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.logo = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            store_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.getList();
        },
        getStoreTypeSelect(){
            store_type_select().then((res) => {
                this.typeList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 确定
        submitModal(){
            store_save(this.formData).then( res => {
                this.getList();
                this.modals = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelModal() {
            this.modals = false;
        },
        goModal(row){
            if(row.name){
                this.modalTitle = '编辑门店';
                this.formData.id = row.id;
                this.formData.name = row.name;
                this.formData.logo = row.logo;
                this.show_logo = row.show_logo;
                this.formData.type_id = row.type_id;
                this.formData.address = row.address;
            }else{
                this.modalTitle = '新增门店';
                this.formData.id = "";
                this.formData.name = "";
                this.formData.logo = "";
                this.show_logo = "";
                this.formData.type_id = "";
                this.formData.address = "";
            }
            setTimeout(() => {
                this.modals = true;
            }, 300);
        },
        goDel(row){
            let that = this;
            this.$Modal.confirm({
                title: '删除提示',
                content: '确认删除吗？一经删除无法复原',
                onOk: () => {
                    store_delete({ id:row.id }).then(res=>{
                        that.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
        changeStatus(row, e){
            let that = this;
            this.$Modal.confirm({
                title: '提示',
                content: '是否修改门店状态？',
                onOk: () => {
                    store_status({ id:row.id }).then(res=>{
                        that.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table_picture{
    margin: 12px 0;
    width: 60px;
    height: 60px;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px dashed #9FA5BB;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
</style>